<template>
  <section v-if="awards?.length || $isPageEditing" class="awards-carousel">
    <div class="container">
      <div v-if="renderContent" class="awards-carousel__content">
        <div class="awards-carousel__nav">
          <button :id="`awards-carousel__nav-btn__prev__${uid}`" class="awards-carousel__nav-btn">
            <i class="icon-Arrow-Back" />
          </button>
        </div>

        <swiper
          :space-between="40"
          :modules="swiperModules"
          slides-per-view="auto"
          center-insufficient-slides
          :navigation="{
            prevEl: `#awards-carousel__nav-btn__prev__${uid}`,
            nextEl: `#awards-carousel__nav-btn__next__${uid}`,
          }"
          class="awards-carousel__swiper"
        >
          <swiper-slide v-for="award in awards" :key="award.name">
            <div class="awards-carousel__slide">
              <img v-if="award.image" :src="award.image.src" :alt="award.image.alt" />
            </div>
          </swiper-slide>
        </swiper>

        <div class="awards-carousel__nav">
          <button :id="`awards-carousel__nav-btn__next__${uid}`" class="awards-carousel__nav-btn">
            <i class="icon-Arrow-Forward" />
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, A11y } from 'swiper/modules';
import useId from '../../composables/useId';
import {
  getFoodHygieneRatingBadge,
  type HygieneRatingBadge,
} from '../../assets/food-hygiene-ratings/_fhr';
import type { VenueAward } from '@/types';
import type { AwardsCarouselProps } from './types';

const swiperModules = [Navigation, A11y];

const uid = useId();

const props = withDefaults(defineProps<AwardsCarouselProps>(), {
  fields: () => ({}),
  params: () => ({}),
});

const hygieneRatingBadge = ref<HygieneRatingBadge | null>(null);
const renderContent = ref(false);

const awards = computed<VenueAward[]>(() => {
  const items = props.fields.awards?.value || [];
  return hygieneRatingBadge.value
    ? [{ name: 'Hygiene rating', image: hygieneRatingBadge.value }, ...items]
    : items;
});

onBeforeMount(async () => {
  if (props.fields.hygieneRating?.value && props.fields.venueCountry?.value) {
    hygieneRatingBadge.value = await getFoodHygieneRatingBadge(
      props.fields.hygieneRating.value,
      props.fields.venueCountry.value
    );
  }
  renderContent.value = true;
});
</script>

<style lang="scss">
@import './scss/AwardsCarousel.scss';
</style>
